<style lang="stylus" scoped>
    .recommend-templates
        display flex
        flex-wrap wrap
        column-gap 24px
        row-gap 24px
        margin-top 40px
        .template-title
            width 100%
            height 24px
            font-size 16px
            color #000
            font-weight 700
        .template-content
            width 100%
            height 100%
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(198px, 1fr));
            grid-gap: 24px;
            .template-item
                display flex
                flex-direction column
                justify-content space-between
                position relative
                min-height 172px
                max-height 202px
                border-radius 8px
                background #F2F4F9
                border 1px solid transparent
                &:hover
                    border-color var(--themeColor)
                    .template-mask
                        display block
                .template-imgbox
                    min-height 124px
                    max-height 154px
                    border-radius 6px
                    background #fff
                    margin 8px
                    margin-bottom 0
                    flex-grow 1
                    img
                        height 100%
                        width 100%
                        object-fit contain
                .template-text
                    width 100%
                    height 40px
                    padding 0 12px
                    line-height 40px
                    >p
                        width 100%
                        height 100%
                        font-size 12px
                        color #000
                        textOverflow()
                .template-mask
                    display none
                    position absolute
                    left 0
                    top 0
                    width 100%
                    height 100%
                    background rgba(0,0,0,.4)
                    z-index 1
                    border-radius 6px
                    cursor pointer
                    .use-btn
                        position absolute
                        top 0
                        right 0
                        bottom 0
                        left 0
                        margin auto
                        height 32px
                        line-height 32px
                        width 100px
                        text-align center
                        border-radius 4px
                        background #017fff
                        font-size 12px
                        color #fff
                        cursor pointer
                        padding 0 5px
                        textOverflow();
                    .vip-tag
                        position absolute
                        left 0
                        top 0
                        background linear-gradient(98deg, #ffedd1, #ffcf88)
                        padding 0 5px
                        height 24px
                        line-height 24px
                        text-align center
                        border-radius: 8px 0 8px 0
                        font-weight 700
                        font-size 11px
                        color #642515
            .template-empty
                cursor pointer
                .template-imgbox
                    display flex
                    justify-content center
                    align-items center
                    img
                        width 24px
                        height 24px
    .recommend-templates-next
        width 100%
        height 1px
    .templates-wrapper
        position relative
        // overflow hidden
        min-height calc(100% - 498px)
        padding-bottom 185px
        flex 1
        margin-bottom -1px
    .page-bottom-bar
        position absolute
        width 100%
        bottom 0
    .to-template-store
        margin-top: 40px
        display flex
        justify-content center
        align-items center
        padding 10px 24px
        font-size 14px
        line-height 18px
        color #017fff
        cursor pointer
        img
            display block
            width 16px
            height 16px
        &:hover
            opacity 0.8
    .bottom-tip-wrapper
        width calc(100% + 80px);
        margin 10px -40px 0
        position relative
        overflow hidden
    .page-bottom-bg
        width 100%
        height 100%
        position absolute
        background linear-gradient(to right, #BBFFAA, #48DEFF),linear-gradient(to bottom, #fff, rgba(255,255,255,0.6))
        background-blend-mode screen
        transition: all 0.1s ease-in-out
    .page-bottom-tip
        display flex
        justify-content center
        width 100%
        position relative
        img
            display block
            width 274px
</style>

<template>
    <div class="templates-wrapper">
        <div class="recommend-templates">
            <div class="template-title">{{ $t("templateType", { type: type }) }}</div>

            <div class="template-content">
                <div class="template-item template-empty" v-if="emptyText" @click="createEmptyFile">
                    <div class="template-imgbox">
                        <img src="@/home/assets/img/newPage/recommend-new/add.svg" alt="" />
                    </div>
                    <div class="template-text">
                        <p :title="emptyText">{{ emptyText }}</p>
                    </div>
                </div>
                <div class="template-item" v-for="item in list" :key="item.id" @click="openTem(item)">
                    <div class="template-imgbox">
                        <img :src="item.img_url" alt="" />
                    </div>
                    <div class="template-text">
                        <p :title="item.name">{{ item.name }}</p>
                    </div>
                    <div class="template-mask">
                        <div class="use-btn" :title="$t('use')">{{ $t("use") }}</div>
                        <div v-if="item.type == 'mfree'" class="vip-tag">{{ $t(vipTag) }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="nextEl" class="recommend-templates-next"></div>
        <div class="page-bottom-bar" v-if="showBottom">
            <div class="to-template-store" @click="toStore">
                <span>{{ $t("toStore") }}</span>
                <img :src="require('@/home/assets/img/newPage/recommend-new/arrow-right.svg')" alt="" />
            </div>
            <div class="bottom-tip-wrapper">
                <div class="page-bottom-bg"></div>
                <div class="page-bottom-tip">
                    <img :src="require('@/home/assets/img/newPage/recommend-new/bottom-tip.png')" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import { openNewTab } from "@/public/utils/tool";
    import appConfig from "@/public/globalConfig";

    @Component
    export default class RecommendTemplate extends Vue {
        @Prop()
        list;
        @Prop()
        type;
        @Prop()
        emptyText;
        @Prop()
        lv2Libs;
        @Prop()
        diagramTypeForTrack;
        @Prop()
        templateClass;
        @Prop()
        nameForStore;
        @Prop({ default: false })
        fromSearch;
        @Prop({ default: false })
        showBottom;

        get notLogin() {
            return !(this.userInfo && Object.keys(this.userInfo).length > 0);
        }
        get userInfo() {
            return this.$store.state.userInfo || (this.$store.state.user && this.$store.state.user.userInfo) || {};
        }
        get vipTag() {
            if (this.vip) {
                return "vipTag";
            } else {
                return "vipTry";
            }
        }

        setLibs(libs?: Array<number>) {
            if (libs) {
                localStorage.setItem("libs", JSON.stringify(libs));
            } else {
                localStorage.setItem("libs", "[373, 14, 4]");
            }
        }
        openTem(item) {
            if (this.notLogin) {
                this.$bus.$emit("login");
                return;
            }
            if (this.fromSearch) {
                this.$emit("openTemplate");
            }
            this.sensors.track("RecommendedTemplateClick", {
                Catalogues: "RecommendedTemplate",
                template_type: `${item.type !== "free" ? "embedVip" : "embedFree"}`,
                template_class: this.templateClass,
                template_name: item.name || "notUseTemplate",
                click_source: "recommendationPage",
            });
            let typeTrack = this.diagramTypeForTrack ? this.diagramTypeForTrack : "default";
            this.sensors.track("clickEmbedTemplate", {
                Catalogues: "Templates",
                diagram_type: typeTrack,
                platform: "online",
            });

            if (this.isPlugin) {
                this.setLibs(item.libs);
                location.href = `${window.location.origin}${appConfig["sourcePath"]}app.html?plugin=board&useTemplate=0&tid=${item.id}`;
                return;
            }
            let maxAction = this.$store.state.appState;
            if (maxAction) {
                if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
                return;
            }
            this.setLibs(item.libs);
            //会员功能限制
            // if (!this.internal && this.lang == "en" && !this.vip) {
            //     if (item.type !== "free") {
            //         this.$store.commit("toPublicStatus", {
            //             type: "upgradeTrigger",
            //             data: "vipTemplate",
            //         });
            //         this.$bus.$emit("togglePromodal", true, 1, 1);
            //         return;
            //     }
            // } else {
            //     if (item.type !== "free" && !ts.$checkAuth({ type: "mfree", buyTrigger: "vipTemplate" }, "buyframe")) return;
            // }
            let newTab: any;
            let newTabCallback;
            let cancelOpen;
            if (!this.openInTabs) {
                // newTab = window.open(`${window.location.origin}${(<any>this.$router).options.base}app.html`, "");
                let task = openNewTab(`${window.location.origin}${(<any>this.$router).options.base}app.html`, this.$edMessage.destroy);
                newTabCallback = task.openTab;
                cancelOpen = task.cancelOpen;
                this.$edMessage.info(this.$tc("newPageCreateFile"), 0);
            }

            let limitCallback = (type = "") => {
                newTab && newTab.close();
                cancelOpen && cancelOpen();
                this.$edMessage.destroy();
                this.sensors.track("useEmbedTemplate", {
                    Catalogues: "openFileProcess",
                    result: "remindSubscribe",
                    template_type: `${item.type !== "free" ? "embedVip" : "embedFree"}`,
                });
                if (type == "showLimitModal") {
                    this.$bus.$on("limitModalContinue", () => {
                        this.$bus.$off("limitModalContinue");
                        this.openTem(item);
                    });
                    this.$store.commit("setState", {
                        type: "showLimitFileModal",
                        data: true,
                    });
                } else if (type == "showLimitCloudSpaceVIP") {
                    if (this.fuser) {
                        this.$bus.$emit("showCloudSpaceVipTips");
                    } else {
                        this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                    }
                } else if (type == "showLimitCloudSpace") {
                    this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "showUpgrade",
                        data: "fileNum",
                    });
                }
            };
            let enterCanvasTrack = `&file_source=templateFile&template_type=noTemplate&diagram_type=${typeTrack}&fromNull=1`;
            if (item.type !== "free") {
                enterCanvasTrack += "&vipTemplate=1";
                if (!this.vip) {
                    this.sensors.track("tryVipBenefit", {
                        Catalogues: "editFileProcess",
                        trial_vip_benefit: "vipTemplate",
                    });
                }
            }
            this.$openFile({
                params: {
                    template_id: item.id,
                },
                fileType: "newPageTemplate",
                suffix: enterCanvasTrack,
                checkLimit: true,
                limitRange: this.$store.state.publicStore.runPlatform,
                limitCallback: limitCallback,
                vip: this.vip,
                isFullCouldSpace: this.isFullCouldSpace,
            }).then((obj) => {
                if (obj.status == "succ") {
                    this.addTemplateRecent(item.id);
                    item.use_num += 1;
                    this.$gaTrack("openFileProcess_clickTemplates", `templateType: ${item.type !== "free" ? "embedVip" : "embedFree"}`);
                    this.$gaTrack(
                        "openFileProcess_useEmbedTemplate",
                        `result: success, templateType: ${item.type !== "free" ? "embedVip" : "embedFree"}`
                    );
                    this.$gaTrack(
                        "openFileProcess_enterCanvas",
                        `fileSource: templateFile, templateType: ${item.type !== "free" ? "embedVip" : "embedFree"}`
                    );
                    this.sensors.track("useEmbedTemplate", {
                        Catalogues: "openFileProcess",
                        result: "successEnterCanvas",
                        template_type: `${item.type !== "free" ? "embedVip" : "embedFree"}`,
                    });
                    this.sensors.track("generateCloudFile", {
                        Catalogues: "openFileProcess",
                        file_source: "templateFile",
                    });
                    this.sensors.track("newFile", {
                        Catalogues: "openFileProcess",
                        new_file_type: "templates",
                        new_file_way: "recommend",
                    });
                    if (this.openInTabs) {
                        location.href = obj.url;
                    } else {
                        this.$edMessage.destroy();
                        newTab = newTabCallback(obj.url);
                        let timer = setInterval(() => {
                            try {
                                newTab.name;
                                newTab.name = obj.obj;
                                clearInterval(timer);
                            } finally {
                            }
                        }, 500);
                    }

                    // add open record
                    let key = obj.obj;
                    let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                    if (!openTabs.includes(key)) {
                        openTabs.push(key);
                    }
                    this.$store.commit("addWin", newTab);
                    localStorage.setItem("openTabs", JSON.stringify(openTabs));
                } else {
                    if (obj.msg == "file num over limit") {
                        limitCallback();
                    } else if (obj.msg == "space storage not enough") {
                        newTab && newTab.close();
                        (<any>this).$edMessage.warn(this.$t("space"));
                    }
                }
            });
        }
        createEmptyFile(libs = []) {
            let ts: any = this;
            if (this.notLogin) {
                ts.$bus.$emit("login");
                return;
            }
            let maxAction = this.$store.state.appState;
            let typeTrack = this.diagramTypeForTrack ? this.diagramTypeForTrack : "default";
            if (maxAction) {
                if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
                return;
            }

            if (libs.length == 0) {
                this.setLibs(this.lv2Libs);
            } else {
                this.setLibs(libs);
            }

            if (this.isPlugin) {
                location.href = `${window.location.origin}${appConfig["sourcePath"]}app.html?plugin=board`;
                return;
            }

            let newTab: any;
            let newTabCallback;
            let cancelOpen;
            if (!this.openInTabs) {
                let task = openNewTab(`${window.location.origin}${appConfig["sourcePath"]}app.html`, this.$edMessage.destroy);
                newTabCallback = task.openTab;
                cancelOpen = task.cancelOpen;
                this.$edMessage.info(this.$tc("newPageCreateFile"), 0);
            }

            let limitCallback = (type = "") => {
                newTab && newTab.close();
                cancelOpen && cancelOpen();
                this.$edMessage.destroy();
                if (type == "showLimitModal") {
                    this.$bus.$on("limitModalContinue", () => {
                        this.$bus.$off("limitModalContinue");
                        this.createEmptyFile();
                    });
                    this.$store.commit("setState", {
                        type: "showLimitFileModal",
                        data: true,
                    });
                } else if (type == "showLimitCloudSpaceVIP") {
                    if (this.fuser) {
                        this.$bus.$emit("showCloudSpaceVipTips");
                    } else {
                        this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                    }
                } else if (type == "showLimitCloudSpace") {
                    this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "showUpgrade",
                        data: "fileNum",
                    });
                }
            };

            let enterCanvasTrack = `&file_source=emptyFile&template_type=noTemplate&diagram_type=${typeTrack}&fromNull=1`;

            this.$openFile({
                params: {
                    newFileName: this.$t("newFile"),
                    libs: JSON.parse(localStorage.getItem("libs") || "[]"),
                    platform: this.$store.state.publicStore.runPlatform,
                },
                fileType: "emptyFile",
                suffix: enterCanvasTrack,
                checkLimit: true,
                limitRange: this.$store.state.publicStore.runPlatform,
                limitCallback: limitCallback,
                vip: this.vip,
                isFullCouldSpace: this.isFullCouldSpace,
            }).then((obj) => {
                this.$gaTrack("openFileProcess_enterCanvas", `fileSource: emptyFile}`);
                this.sensors.track("generateCloudFile", {
                    Catalogues: "openFileProcess",
                    file_source: "templateFile",
                });
                this.sensors.track("newFile", {
                    Catalogues: "openFileProcess",
                    new_file_type: "emptyFile",
                    new_file_way: "recommend",
                });
                if (this.openInTabs) {
                    location.href = obj.url;
                } else {
                    this.$edMessage.destroy();
                    newTab = newTabCallback(obj.url);
                }
                this.$store.commit("setAppState", "create");
                let timer = setInterval(() => {
                    try {
                        newTab.name;
                        newTab.name = obj.obj;
                        if (!newTab.name) {
                            this.$store.commit("setAppState", "");
                            clearInterval(timer);
                        }
                        if (!newTab.location.hash) {
                            this.$store.commit("setAppState", "");
                            clearInterval(timer);
                        }
                    } finally {
                    }
                }, 1000);

                // add open record
                let key = obj.obj;
                let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                if (!openTabs.includes(key)) {
                    openTabs.push(key);
                }
                this.$store.commit("addWin", newTab);
                localStorage.setItem("openTabs", JSON.stringify(openTabs));
            });
        }

        addTemplateRecent(id) {
            if (this.isPlugin) return;
            if (!this.$validateLogin()) return;
            this.$edApi.addTemplateHistory({
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                data: {
                    template_id: id,
                    template_from: "TEMPLATE",
                },
            });
        }

        initBottomTip() {
            let isBouncing = false; // 假设一个变量来标记是否正在回弹
            document.querySelector(".recommend-page-scroll .xx-scrollbar-view").addEventListener("scroll", (e) => {
                const dom = e.target as HTMLElement;
                if (Math.abs(dom.scrollHeight - dom.clientHeight - dom.scrollTop) < 1 && !isBouncing) {
                    isBouncing = true;
                    let tipDom = document.querySelector(".page-bottom-bg") as HTMLElement;
                    tipDom.style.opacity = "1";
                    setTimeout(() => {
                        tipDom.style.opacity = "0.5";
                        dom.scrollTop -= 0.1;
                        isBouncing = false;
                    }, 1000);
                }
            });
        }

        toStore() {
            let url = "https://www.edrawmax.cn/templates/";
            if (this.nameForStore && this.nameForStore !== "常用图示") {
                url += `search/${this.nameForStore}`;
            }
            if (!this.internal) {
                this.$store.commit("setState", {
                    type: "templateSelect",
                    data: "index",
                });
                this.$router.push({
                    path: `/${this.lang}/store`,
                    query: {
                        keyword: this.nameForStore,
                    },
                });
                this.comunityTrack();
                return;
            }
            this.aClick(url);
            this.comunityTrack();
        }

        comunityTrack() {
            let sensorObj = {
                Catalogues: "RecommendedTemplate",
                classification: "", //待定
            };
            sensorObj.classification = this.templateClass.indexOf(this.diagramTypeForTrack) > -1 ? this.templateClass : this.diagramTypeForTrack;
            this.sensors.track("clickEndCommunityLink", sensorObj);
        }

        aClick(href) {
            let a = document.createElement("a");
            a.href = href;
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        observer = null;
        nextPageListener() {
            let el = this.$refs.nextEl as HTMLElement;
            if (this.observer) {
                this.observer.unobserve(el);
            } else {
                this.observer = new IntersectionObserver((entries) => {
                    if (entries[0] && entries[0].isIntersecting) {
                        this.$emit("nextPage");
                    }
                });
                this.observer.observe(el);
            }
        }

        created() {}
        mounted() {
            this.showBottom && this.initBottomTip();
            this.nextPageListener();
        }
        beforeDestroy() {
            this.nextPageListener();
        }
    }
</script>
<i18n>
{
    "zh": {
        "use": "使用模板",
        "templateType": "精选{type}模板",
        "vipTag": "VIP专享",
        "vipTry": "免费试用",
        "toStore": "前往模板社区获取更多模板",
        "newFile": "未命名文件",
        "space": "云空间已达上限， 删除文件或清理回收站",
        "create": "正在创建文件中，请稍后再试"
    },
    "en": {
        "use": "Use Template",
        "templateType": "Featured {type} Templates",
        "vipTag": "Premiun",
        "vipTry": "Free Trial",
        "toStore": "Explore more templates in Templates Community",
        "newFile": "Unnamed File",
        "space": "Space storage not enough, delete files or upgrade to premium version to solve it.",
        "create": "Creating file, please try again later."
    },
    "fr": {
        "use": "Utiliser le modèle",
        "templateType": "Modèles {type} en vedette",
        "vipTag": "Premium",
        "vipTry": "Essai gratuit",
        "toStore": "Découvrez d'autres modèles dans la Communauté de modèles",
        "newFile": "Fichier sans nom",
        "space": "L'espace cloud a atteint la limite supérieure, supprimer des fichiers ou nettoyer la corbeille",
        "create": "Création du fichier, veuillez réessayer plus tard"
    },
    "de": {
        "use": "Vorlage verwenden",
        "templateType": "Empfohlene {type}-Vorlagen",
        "vipTag": "Premium",
        "vipTry": "Kostenlose Testversion",
        "toStore": "Entdecken Sie weitere Vorlagen in der Vorlagen-Community",
        "newFile": "Unbenannte Datei",
        "space": "Speicherplatz nicht ausreichend, Dateien löschen oder auf Premium-Version aktualisieren, um das Problem zu lösen",
        "create": " Datei wird erstellt, versuchen Sie es später erneut"
    },
    "jp": {
        "use": "テンプレートを使用する",
        "templateType": "おすすめの{type}テンプレート",
        "vipTag": "プレミアム",
        "vipTry": "無料トライアル",
        "toStore": "テンプレートコミュニティで他のテンプレートを探す",
        "newFile": "名前のないファイル",
        "space": "クラウドスペースが上限に達した、ファイルを削除、またはごみ箱をクリーンアップしてください",
        "create": "ファイルを作成しています。しばらくしてからもう一度お試しください"
    },
    "es": {
        "use": "Usar plantilla",
        "templateType": "Plantillas de {type} destacadas",
        "vipTag": "Premium",
        "vipTry": "Prueba gratuita",
        "toStore": "Explora más plantillas en la Comunidad de plantillas",
        "newFile": "Archivo sin nombre",
        "space": "El espacio de almacenamiento no es suficiente, elimine archivos o actualice a la versión premium para resolverlo",
        "create": "Creando archivo, por favor intente nuevamente más tarde."
    },
    "pt": {
        "use": "Usar modelo",
        "templateType": "Modelos {type} em destaque",
        "vipTag": "Premium",
        "vipTry": "Avaliação gratuita",
        "toStore": "Explore mais modelos na Comunidade de modelos",
        "newFile": "Ficheiro Sem Nome",
        "space": "Espaço de armazenamento insuficiente, eliminar ficheiros ou fazer upgrade para a versão premium para resolver o problema.",
        "create": "Criando ficheiro, por favor, tentar mais tarde."
    },
    "it": {
        "use": "Usa il modello",
        "templateType": "Modelli {type} in primo piano",
        "vipTag": "Premium",
        "vipTry": "Versione di prova gratuita",
        "toStore": "Scopri altri modelli nella community dei modelli",
        "newFile": "File Senza Nome",
        "space": "Spazio di archiviazione insufficiente. Si prega di eliminare dei file o di eseguire l'upgrade alla versione premium.",
        "create": "Creazione file in corso. Si prega di riprovare."
    },
     "tw": {
        "use": "使用模板",
        "templateType": "精选{type}模板",
        "vipTag": "Premium",
        "vipTry": "免費試用",
        "toStore": "前往模板社区获取更多模板",
        "newFile": "未命名檔案",
        "space": "雲端硬碟已達上限， 刪除檔案或清理回收站",
        "create": "正在建立檔案中，請稍後再試"
    },
    "kr": {
        "use": "템플릿 사용",
        "templateType": "精选{type}模板",
        "vipTag": "회원무료",
        "vipTry": "무료 평가판",
        "toStore": "前往模板社区获取更多模板",
        "newFile": "이름이없는 파일",
        "space": "클라우드 공간이 상한에 도달했습니다. 파일을 삭제하거나 휴지통을 비우십시오.",
        "create": "파일을 만드는 중입니다. 나중에 다시 시도하세요~"
    }
}
</i18n>
